import React, { useEffect, useRef } from 'react'
import { X } from 'lucide-react'

export default function FilterDropdown({ isOpen, onClose, options, selectedValues, onSelect, title }) {
  const dropdownRef = useRef(null)

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        onClose()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [onClose])

  const handleSelect = (value) => {
    if (value === null) {
      // If "All" is selected, clear all selections and close dropdown
      onSelect([]);
      onClose();
    } else {
      // Toggle the selected value
      const newSelected = selectedValues.includes(value)
        ? selectedValues.filter(v => v !== value)
        : [...selectedValues, value];
      onSelect(newSelected);
    }
  };

  if (!isOpen) return null;

  return (
    <div 
      ref={dropdownRef}
      className="absolute left-0 mt-2 w-64 bg-white rounded-lg shadow-lg z-50 border"
    >
      <div className="p-3 border-b">
        <div className="text-sm font-medium">{title}</div>
      </div>
      <div className="max-h-64 overflow-y-auto">
        <div className="p-2">
          <button
            className={`w-full text-left px-3 py-2 rounded-md hover:bg-gray-100 text-sm ${
              selectedValues.length === 0 ? 'bg-gray-50' : ''
            }`}
            onClick={() => handleSelect(null)}
          >
            All
          </button>
          {options.map((option) => (
            <button
              key={option.key}
              className={`w-full text-left px-3 py-2 rounded-md hover:bg-gray-100 text-sm flex items-center justify-between ${
                selectedValues.includes(option.key) ? 'bg-gray-50' : ''
              }`}
              onClick={() => handleSelect(option.key)}
            >
              <span>{option.key}</span>
              <div className="flex items-center gap-2">
                {option.doc_count && (
                  <span className="text-gray-400 text-xs">{option.doc_count}</span>
                )}
                {selectedValues.includes(option.key) && (
                  <X size={16} className="text-gray-500 hover:text-gray-700" />
                )}
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
} 